function escapeStringForRegularExpression(str) {
  // disabling the next line in eslint since it's a crazy regex from the internet.
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'); // oxlint-disable-line
}

export class StringHelperService {
  static replaceAll(str, search, replacement) {
    return str.replace(new RegExp(escapeStringForRegularExpression(search), 'g'), replacement);
  }

  static idify(str) {
    return this.replaceAll(str.toLowerCase(), ' ', '-');
  }

  static removeAllNonNumericCharacters(str) {
    return str.replace(/[^0-9.,-]/g, '');
  }
}
